<template>
  <div class="partners-list">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
      <Col :xs="24" :sm="12">
        <a style="margin-top:4px;" href="/template/园区导入模版.xlsx" class="f-r ml10">下载导入模版</a>
        <Button @click="showImportModel()" type="success" class="f-r">导入</Button>
      </Col>
    </Row>
    <Row>
      <Col :xs="8" :sm="8">
        <Alert>园区交易规模：¥{{ order_total_price }}</Alert>
        <div style="float: left;"></div>
      </Col>
      <Col :xs="8" :sm="8">
        <Alert>平台商城服务手续费：¥{{ plat_service_price }}</Alert>
        <div style="float: left;"></div>
      </Col>
      <Col :xs="8" :sm="8">
        <Alert>平台云服务手续费：¥{{ cloud_service_price }}</Alert>
        <div style="float: left;"></div>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showImportModalStatus"
      title="导入任务"
      @on-ok="importPark('leadInValidate')"
      :loading="loading"
    >
      <Form
        :model="leadIn"
        ref="leadInValidate"
        :rules="leadInValidate"
        action="javascript:void(0)"
      >
        <FormItem label="选择文件" prop="filePath">
          <!--<upload-question v-model="leadIn.filePath" :defaultList="fileListThree" ref="import-filesThree"></upload-question>-->
          <file-import
            v-model="leadIn.filePath"
            :defaultList="fileListThree"
            ref="import-filesThree"
          ></file-import>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="biliStatus" title="平台收取使用服务费（含融宝）" @on-ok="updateBili()" :loading="loading">
      <Form :model="biliModel" :label-width="136">
        <FormItem label="商城服务费收取比例：" label-position="top">
          <Input v-model="biliModel.on_fx" placeholder="例如10"></Input>
        </FormItem>
        <FormItem label="云服务费收取比例：" label-position="top">
          <Input v-model="biliModel.underline_fx" placeholder="例如10"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="600"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="parkInfo" :label-width="60" ref="parkInfoValidate" :rules="parkInfoValidate">
        <FormItem label="uuid" label-position="top">{{ parkInfo.park_uuid }}</FormItem>
        <FormItem label="昵称" label-position="top">{{ parkInfo.nickname }}</FormItem>
        <FormItem label="手机号" label-position="top">{{ parkInfo.phone }}</FormItem>
        <FormItem label="姓名" label-position="top" prop="name">
          <Input v-model="parkInfo.name"></Input>
        </FormItem>
        <FormItem label="等级" prop="level">
          <Input v-model="parkInfo.level"></Input>
        </FormItem>
        <FormItem label="企业名称" prop="company">
          <Input v-model="parkInfo.company"></Input>
        </FormItem>
        <FormItem label="企业代码" prop="company_code">
          <Input v-model="parkInfo.company_code"></Input>
        </FormItem>
        <Row :gutter="32">
          <Col span="8">
            <FormItem label="省-市-县" label-position="top">
              <Select v-model="parkInfo.province_id" placeholder="省" @on-change="shengChange">
                <Option v-for="item in shengList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label=" " label-position="top">
              <Select v-model="parkInfo.city_id" placeholder="市" @on-change="shiChange">
                <Option v-for="item in shiList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label=" " label-position="top">
              <Select v-model="parkInfo.area_id" placeholder="县">
                <Option v-for="item in quList" :value="item.id" :key="item.id">{{item.areaname}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="详细地址" label-position="top">
          <Input v-model="parkInfo.address" placeholder="如道路、门牌号、小区、楼栋号等..."></Input>
        </FormItem>
        <FormItem label="简介" prop="describe">
          <Input v-model="parkInfo.describe" type="textarea" :rows="4" placeholder="简介..."></Input>
        </FormItem>
        <FormItem label="协议" prop="agreement">
          <Input v-model="parkInfo.agreement" type="textarea" :rows="4" placeholder="简介..."></Input>
        </FormItem>
        <FormItem label="头像" prop="imagetouxiang">
          <upload-thumb
            v-model="parkInfo.thumb"
            ref="imagetouxiang"
            :defaultList="touxiangList"
            :autoCropWidth="100" :autoCropHeight="100"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="身份证正面照" prop="imageface">
          <upload-thumb
            v-model="parkInfo.imageface"
            ref="imagefaceuploadthumb"
            :defaultList="imagefacethumblist"
            :autoCropWidth="100" :autoCropHeight="100"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照" prop="imageback">
          <upload-thumb
            v-model="parkInfo.imageback"
            ref="imagebackuploadthumb"
            :defaultList="imagebackthumblist"
            :autoCropWidth="100" :autoCropHeight="100"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="营业执照照片" prop="company_photo">
          <upload-thumb
            v-model="parkInfo.company_photo"
            ref="uploadthumb"
            :defaultList="thumblist"
            :autoCropWidth="154" :autoCropHeight="154"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <!-- <FormItem label="融宝商户号" prop="mcid">
          <Input v-model="parkInfo.mcid"></Input>
        </FormItem>
        <FormItem label="上传融宝公钥文件" prop="public_key">
          <file-import
            v-model="parkInfo.public_key"
            :defaultList="fileListOne"
            ref="import-filesone"
          ></file-import>
        </FormItem>
        <FormItem label="上传融宝私钥文件" prop="private_key">
          <file-import
            v-model="parkInfo.private_key"
            :defaultList="fileListTwo"
            ref="import-filestwo"
          ></file-import>
        </FormItem>-->
        <FormItem label="是否推到H5" label-position="top">
          <RadioGroup v-model="parkInfo.is_index">
            <Radio :label="0">否</Radio>
            <Radio :label="1">是</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
        <Button type="primary" @click="editPark('parkInfoValidate')">提交</Button>
      </div>
    </Drawer>
    <!--角色管理-->
    <Modal
      v-model="showRoleStatus"
      title
      @on-ok="createRole('roleInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="roleInfo"
        ref="roleInfoValidate"
        :rules="roleInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="角色">
          <CheckboxGroup v-model="roleInfo.role_ids" @on-change="roleCheck">
            <Checkbox v-for="item in roleList" :key="item.id" :label="item.id">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
    </Modal>
    <!--积分兑换规则管理-->
    <Modal v-model="showScoreRoleStatus" title @on-ok="scoreSubmit()" :loading="loading">
      <Form :model="scoreInfo" action="javascript:void(0)">
        <FormItem label="消费比例">
          <Input
            v-model="scoreInfo.duihuan_money"
            placeholder="请输入..."
            :style="{width:'80px',float:'left'}"
          >
            <span slot="append">%</span>
          </Input>
          <i
            style="color:gray;font-style:normal; font-size:12px;display:block;"
          >*{{ scoreInfo.duihuan_money != 0 ? ('1积分可以兑换（' + scoreInfo.duihuan_money/100 + '）') : '（1积分可以兑换?元）' }}</i>
        </FormItem>
        <FormItem label="赠送比例">
          <Input
            v-model="scoreInfo.duihuan_score"
            placeholder="请输入..."
            :style="{width:'80px',float:'left'}"
          >
            <span slot="append">%</span>
          </Input>
          <i
            style="color:gray;font-style:normal; font-size:12px;display:block;"
          >*{{ scoreInfo.duihuan_score != 0 ? ('消费（' + Math.ceil(1/(scoreInfo.duihuan_score/100)) + '）元可以获得1积分') : '（消费?元可以获得1积分）' }}</i>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
import FileImport from "../common/fileimport";
// import UploadQuestion from '../common/staffimport'

export default {
  name: "park-list",
  data() {
    // const validatePublicKey = (rule, value, callback) => {
    //   if (
    //     !(
    //       this.$refs["import-filesone"].resList != undefined &&
    //       this.$refs["import-filesone"].resList.length
    //     )
    //   ) {
    //     callback(new Error("请上传融宝公钥文件"));
    //   } else {
    //     callback();
    //   }
    // };
    // const validatePrivateKey = (rule, value, callback) => {
    //   if (
    //     !(
    //       this.$refs["import-filestwo"].resList != undefined &&
    //       this.$refs["import-filestwo"].resList.length
    //     )
    //   ) {
    //     callback(new Error("请上传融宝私钥文件"));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      //抽屉参数
      value3: false,
      isable: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      biliModel: { on_fx: null, underline_fx: null },
      isClear: false,
      loading: true,
      dataloading: true,
      order_total_price: "0.00",
      plat_service_price: "0.00",
      cloud_service_price: "0.00",
      imagefacethumblist: [], // 身份证是正面
      imagebackthumblist: [], // 身份证反面
      thumblist: [], // 营业执照
      cates: [],
      cateList: [],
      skillList: [],
      intangibleList: [],
      duihuan_score: null,
      scoreInfo: {
        duihuan_score: "0",
        duihuan_money: "0"
      },
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "用户",
          key: "name",
          minWidth: 350,
          render: (h, params) => {
            var a = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.username != null
            )
              a = params.row.userdata.username;
            var b = "";
            if (params.row.company != null) b = params.row.company;
            var c = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.nickname != null
            )
              c = params.row.userdata.nickname;
            var d = "";
            if (params.row.userdata != null && params.row.userdata.uuid != null)
              d = params.row.userdata.uuid;
            var e = "";
            if (params.row.user != null && params.row.user.openid != null)
              e = params.row.user.openid;
            var f = "";
            if (
              params.row.user != null &&
              params.row.user.map_mp_openid != null
            )
              f = params.row.user.map_mp_openid;
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "用户名：" + a
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "名称：" + b
              ),
              h(
                "p",
                {
                  style: {
                    color: "#3c763d"
                  }
                },
                "昵称：" + c
              ),
              h(
                "p",
                {
                  style: {
                    color: "#337ab7"
                  }
                },
                "用户ID：" + d
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "微信ID：" + e
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "小程序ID：" + f
              )
            ]);
          }
        },
        {
          title: "电话",
          key: "userdata.username",
          width: 150,
          render: (h, params) => {
            var s = "";
            if (
              params.row.userdata != null &&
              params.row.userdata.username != null
            )
              s = params.row.userdata.username;
            return h("span", s);
          }
        },
        {
          title: "注册时间",
          key: "created_at",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 520,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            var s = this.status == 1 ? "none" : "inline-block";
            var m = this.status != 1 ? "none" : "inline-block";
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.levelrule(params.row.park_uuid);
                    }
                  }
                },
                "等级规则"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.scoreDetail(params.row.park_uuid);
                    }
                  }
                },
                "积分兑换规则"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.roleDetail(params.row.id);
                    }
                  }
                },
                "角色"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.park_uuid);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: s
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.gofirstagentlist(params.row.park_uuid);
                    }
                  }
                },
                "一级分销商"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: s
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.gotradesmanlist(params.row.park_uuid);
                    }
                  }
                },
                "商户"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: s
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.goagentlist(params.row.park_uuid);
                    }
                  }
                },
                "二级分销商"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    marginTop: "2px",
                    display: s
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.gotcrecord(params.row.park_uuid);
                    }
                  }
                },
                "提成记录"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    marginTop: "2px",
                    display: s
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.setservice(params.row.park_uuid);
                    }
                  }
                },
                "设置服务费"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    marginTop: "2px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.tongjiparkconsume(params.row.park_uuid);
                    }
                  }
                },
                "统计收入"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      showScoreRoleStatus: false,
      parkInfo: {
        park_uuid: "",
        name: "",
        company: "",
        company_code: "",
        image: "",
        describe: "",
        company_photo: "",
        agreement: "",
        mcid: "",
        public_key: "",
        private_key: "",
        registe_at: "",
        is_index: 0
      },
      fileListOne: [],
      fileListTwo: [],
      fileListThree: [],
      parkInfoValidate: {
        name: [{ required: true, message: "姓名必须填写", trigger: "blur" }]
        // mcid: [{ required: true, message: "商户号必须填写", trigger: "blur" }],
        // public_key: [
        //   { required: true, validator: validatePublicKey, trigger: "change" }
        // ],
        // private_key: [
        //   { required: true, validator: validatePrivateKey, trigger: "change" }
        // ]
      },
      status: 1,
      shenheStatus: false,
      shenheId: 0,
      reviewStatus: 0,
      biliStatus: false,
      leadIn: {
        filePath: ""
      },
      showImportModalStatus: false,
      leadInValidate: {
        files: [
          {
            required: true,
            type: "string",
            message: "请选择上传文件",
            trigger: "change"
          }
        ]
      },
      roleInfo: {
        role_ids: []
      },
      roleInfoValidate: {},
      roleList: [],
      id: 0,
      role_ids: [],
      showRoleStatus: false,
      shengList: [],
      shiList: [],
      quList: [],
      touxiangList: []
    };
  },
  created: function() {
    this.$api.merchantRole.list({ size: 10000 }).then(res => {
      this.roleList = res.result.list;
    });
    this.status = this.$route.params.status;
    this.getTableList();
    this.getShengList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo,
    FileImport
    // UploadQuestion
  },
  methods: {
    getTableList: function() {
      this.$api.park
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.order_total_price = res.result.order_total_price;
            this.plat_service_price = res.result.plat_service_price;
            this.cloud_service_price = res.result.cloud_service_price;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    //积分兑换
    scoreDetail(park_uuid) {
      this.showScoreRoleStatus = !this.showScoreRoleStatus;
      this.park_uuid = park_uuid;
      this.$api.park.scoredetail({ park_uuid: park_uuid }).then(res => {
        console.log(res.result);
        if (res.result == null) {
          this.scoreInfo.duihuan_score = "0";
          this.scoreInfo.duihuan_money = "0";
        } else {
          this.scoreInfo = res.result;
        }
      });
    },
    scoreSubmit() {
      this.$api.park
        .scoreedit({
          duihuan_score: this.scoreInfo.duihuan_score,
          duihuan_money: this.scoreInfo.duihuan_money,
          park_uuid: this.park_uuid
        })
        .then(res => {
          if (res.code == 200) {
            this.dataloading = false;
            this.showScoreRoleStatus = false;
            this.$Message.success(res.msg);
          }
        });
    },
    // 详情
    detail(index) {
      this.parkInfo = {
        park_uuid: "",
        name: "",
        company: "",
        company_code: "",
        image: "",
        describe: "",
        company_photo: "",
        agreement: "",
        mcid: "",
        public_key: "",
        private_key: "",
        registe_at: "",
        thumb: ""
      };
      this.imagefacethumblist = [];
      this.imagebackthumblist = [];
      this.thumblist = [];
      this.touxiangList = [];

      this.$refs["parkInfoValidate"].resetFields();

      this.showModalStatus = !this.showModalStatus;
      this.park_uuid = index;
      this.$api.park.detail({ park_uuid: index }).then(res => {
        this.parkInfo.park_uuid = res.result.park_uuid;
        this.parkInfo.nickname = res.result.userdata.nickname;
        this.parkInfo.phone = res.result.user.username;
        this.parkInfo.name = res.result.name;
        this.parkInfo.is_index = res.result.is_index;
        this.parkInfo.company = res.result.company;
        this.parkInfo.company_code = res.result.company_code;
        this.parkInfo.describe = res.result.describe;
        this.parkInfo.agreement = res.result.agreement;
        this.parkInfo.mcid = res.result.mcid;
        this.parkInfo.province_id = res.result.province_id;
        this.parkInfo.city_id = res.result.city_id;
        this.parkInfo.area_id = res.result.area_id;
        this.parkInfo.address = res.result.address;
        this.parkInfo.level = res.result.level;
        if (this.parkInfo.province_id) {
          this.shengChange(this.parkInfo.province_id);
        }
        if (this.parkInfo.city_id) {
          this.shiChange(this.parkInfo.city_id);
        }
        console.log("详细信息====", this.parkInfo);
        if (res.result.thumb) {
          this.parkInfo.thumb = res.result.thumb;
          this.touxiangList.push({
            name: res.result.thumb,
            url: res.result.thumb,
            status: "finished"
          });
        }
        let imgsArr = res.result.imgsArr;
        if (imgsArr.length > 0) {
          this.parkInfo.imageface = res.result.imgsArr[0];
          this.imagefacethumblist.push({
            name: res.result.imgsArr[0],
            url: res.result.imgsArr[0],
            status: "finished"
          });
        }
        if (imgsArr.length > 1) {
          this.parkInfo.imageback = res.result.imgsArr[1];
          this.imagebackthumblist.push({
            name: res.result.imgsArr[1],
            url: res.result.imgsArr[1],
            status: "finished"
          });
        }

        this.parkInfo.company_photo = res.result.company_photo;
        this.thumblist.push({
          name: res.result.company_photo,
          url: res.result.company_photo,
          status: "finished"
        });
        // this.parkInfo.public_key = res.result.public_key;
        // this.fileListOne = [];
        // this.fileListTwo = [];
        // if (this.parkInfo.public_key != "") {
        //   this.fileListOne.push({
        //     url: res.result.public_key,
        //     name: res.result.public_key
        //   });
        // }

        // this.parkInfo.private_key = res.result.private_key;
        // if (this.parkInfo.private_key != "") {
        //   this.fileListTwo.push({
        //     url: res.result.private_key,
        //     name: res.result.private_key
        //   });
        // }
      });
    },
    // 修改
    editPark(name) {
      if (this.$refs["imagefaceuploadthumb"].uploadList.length > 0) {
        this.parkInfo.imageface = this.$refs[
          "imagefaceuploadthumb"
        ].uploadList[0].url;
      } else {
        this.parkInfo.imageface = "";
      }
      if (this.$refs["imagebackuploadthumb"].uploadList.length > 0) {
        this.parkInfo.imageback = this.$refs[
          "imagebackuploadthumb"
        ].uploadList[0].url;
      } else {
        this.parkInfo.imageback = "";
      }
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.parkInfo.company_photo = this.$refs[
          "uploadthumb"
        ].uploadList[0].url;
      } else {
        this.parkInfo.company_photo = "";
      }
      // 头像
      if (this.$refs["imagetouxiang"].uploadList.length > 0) {
        this.parkInfo.thumb = this.$refs["imagetouxiang"].uploadList[0].url;
      } else {
        this.parkInfo.thumb = "";
      }
      // this.parkInfo.public_key = this.$refs["import-filesone"].resList[0].url;
      // this.parkInfo.private_key = this.$refs["import-filestwo"].resList[0].url;
      this.parkInfo.image =
        this.parkInfo.imageface + "," + this.parkInfo.imageback; //否	string	身份证正反图集
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.park.create(this.parkInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus = !this.showModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //等级规则
    levelrule(park_uuid) {
      this.$router.push("/park/levellist/" + park_uuid);
    },
    gofirstagentlist(id) {
      this.$router.push("/parkfirstagent/list/" + id);
    },
    // 去商户列表
    gotradesmanlist(id) {
      this.$router.push("/park/tradesman/" + id);
    },
    // 去园区提成记录
    gotcrecord(id) {
      this.$router.push("/park/tc_record/" + id);
    },
    tongjiparkconsume(id) {
      this.$router.push("/park/MoneyStatistics/" + id);
    },
    // 去代理商户列表
    goagentlist(id) {
      this.$router.push("/park/agentList/" + id);
    },
    // 导入
    showImportModel: function() {
      this.showImportModalStatus = !this.showImportModalStatus;
      this.fileListThree = [];
      this.leadIn.filePath = "";
      // this.fileListThree.push({});
    },
    importPark(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (
            this.$refs["import-filesThree"].resList != undefined &&
            this.$refs["import-filesThree"].resList.length
          ) {
            this.leadIn.filePath = this.$refs[
              "import-filesThree"
            ].resList[0].url;
          } else {
            this.leadIn.filePath = "";
            this.$Message.error("请选择上传文件");
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            return;
          }
          this.$nextTick(() => {
            this.loading = true;
          });
          this.$api.park.import(this.leadIn).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showImportModalStatus = !this.showImportModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //角色详情
    roleDetail(id) {
      this.showRoleStatus = !this.showRoleStatus;
      this.id = id;
      this.roleInfo.role_ids = [];
      this.$api.tradesman.rolelist({ id: id, type: 2 }).then(res => {
        this.roleInfo.role_ids = res.result;
        this.role_ids = res.result;
        console.log(this.roleInfo.role_ids);
      });
    },
    //打开设置服务费框
    setservice: function(index) {
      this.biliStatus = !this.biliStatus;
      this.park_uuid = index;
      this.$api.park.detail({ park_uuid: index }).then(res => {
        this.biliModel.on_fx = res.result.on_fx;
        this.biliModel.underline_fx = res.result.underline_fx;
      });
    },
    //设置园区服务费
    updateBili() {
      this.$api.park
        .serviceedit({
          park_uuid: this.park_uuid,
          on_fx: this.biliModel.on_fx,
          underline_fx: this.biliModel.underline_fx
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.biliStatus = false;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },
    // 选中角色时
    roleCheck(data) {
      this.role_ids = data;
    },
    createRole() {
      this.$api.tradesman
        .roleedit({ role_ids: this.role_ids, id: this.id, type: 2 })
        .then(res => {
          if (res.code == 200) {
            this.showEditInfoStatus = !this.showEditInfoStatus;
            this.$Message.success(res.msg);
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showRoleStatus = !this.showRoleStatus;
        });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 省列表
    getShengList() {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
      console.log("省=====");
    },
    shengChange(value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
      console.log("省++++++");
    },
    shiChange(value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
      console.log("区=====");
    }
  }
};
</script>

<style scoped>
</style>
